import {
  withTranslation,
} from 'react-i18next';

import ChampionshipResultTableRaceResultFieldsView from './ChampionshipResultTableRaceResultFieldsView';

const TranslatedComponent = withTranslation()(ChampionshipResultTableRaceResultFieldsView);

const Component = TranslatedComponent;

export default Component;
